// extracted by mini-css-extract-plugin
export default {"textContainer":"HyperLink_textContainer__caFMz","link":"HyperLink_link__dDlt2"};